/* Delfino — motorul quiz-ului „Construim împreună pachetul" (overlay #dlQuiz).
   Port al motorului live din source/live-supl/dom/home/_inline-18.js (8 trasee × 5 întrebări,
   micro-validări, cross-sell, persistență în localStorage) combinat cu deschiderea/închiderea de
   overlay din _inline-21.js (window.DelfinoQuiz.open/close, Escape, blocarea scroll-ului).

   Diferențe față de live, toate intenționate:
   - etapele trăiesc în overlay-ul global (snippets/quiz-overlay.liquid), nu în secțiunea din pagină,
     ca să poată fi deschis de oriunde: [data-dl-quiz-open], orice link către #quiz, sau /#quiz;
   - recomandarea de produs se ia din <script data-dl-quiz-products> (blocurile secțiunii
     quiz-banner, cu produse reale din Shopify) și cade pe DLQuizData.PRODUCTS când lipsește;
   - când produsul mapat are variantă, CTA-ul din rezultat adaugă direct în coș prin DL.cart.add;
   - Home v2: înaintea alegerii subiectului e un ecran de start (data-stage="start": ce urmează, în
     3 pași, buton „Începe”). Etapele sunt start → intro (subiecte) → quiz → result. „Reia quiz-ul”
     și „Înapoi” de la prima întrebare duc la subiecte, nu la start.

   Se exportă ca window.DelfinoQuiz (globalThis în Node — fără DOM — ca să fie testabil). */
(function (root) {
  'use strict';

  var DATA = root.DLQuizData || {};
  var ALL_PROBLEMS = DATA.ALL_PROBLEMS || [];
  var QUIZ = DATA.QUIZ || {};
  var FALLBACK = DATA.PRODUCTS || {};
  var STORAGE_KEY = 'delfino_quiz_v1';
  var CROSS_NONE = 'Nu, doar problema asta';

  /* Hărți umplute din Liquid (vezi snippets/quiz-overlay.liquid și sections/quiz-banner.liquid) */
  var shopProducts = {};
  var images = {};

  /* ── Helpers ─────────────────────────────────────────────────── */
  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Copiază doar valorile care chiar există: un câmp gol din Liquid (produs fără imagine,
     variantă lipsă) nu trebuie să șteargă fallback-ul din dataset. */
  function merge(target, source) {
    if (!source) return target;
    Object.keys(source).forEach(function (k) {
      var v = source[k];
      if (v === undefined || v === null || v === '') return;
      target[k] = v;
    });
    return target;
  }

  function productFor(key) {
    var base = FALLBACK[key];
    if (!base) return null;
    var out = merge({}, base);
    if (images[key]) out.img = images[key];
    return merge(out, shopProducts[key]);
  }

  /* Problemele „active” = cele cărora comerciantul le-a mapat un produs în blocurile secțiunii
     (quiz-banner). Fără mapare (magazin nou), rămân toate cele 8 din dataset. Așa, traseele fără
     produs (ex. cervical, somn, păr/unghii) dispar din prima întrebare și din cross-sell în loc să
     recomande produsul de rezervă de pe site-ul vechi. */
  function activeProblems() {
    var mapped = ALL_PROBLEMS.filter(function (p) { return !!shopProducts[p.key]; });
    return mapped.length ? mapped : ALL_PROBLEMS;
  }

  /* Întrebarea de cross-sell (ultima din fiecare traseu) e construită din celelalte probleme active. */
  function crossProblems(problemKey) {
    return activeProblems().filter(function (p) { return p.key !== problemKey; });
  }

  function resultFor(problemKey, answers) {
    var path = QUIZ[problemKey];
    var product = productFor(problemKey);
    if (!path || !product) return null;
    var others = crossProblems(problemKey);
    var picked = (answers && answers[path.questions.length - 1]) || [];
    var cross = picked
      .filter(function (i) { return i >= 0 && i < others.length; })
      .map(function (i) { return { key: others[i].key, label: others[i].label, product: productFor(others[i].key) }; })
      .filter(function (c) { return c.product; });
    return merge({ key: problemKey, result: path.result, cross: cross }, product);
  }

  function setProducts(map) { shopProducts = map || {}; }
  function setImages(map) { images = map || {}; }

  /* ── Stare ───────────────────────────────────────────────────── */
  var state = { problem: null, step: 0, answers: [] };
  var validationTimer = null;
  var overlay = null;
  var refs = {};
  var lastTrigger = null;

  function persist(extra) {
    try {
      var snapshot = { problem: state.problem, step: state.step, answers: state.answers, ts: Date.now() };
      if (extra) Object.keys(extra).forEach(function (k) { snapshot[k] = extra[k]; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
    } catch (e) { /* mod privat etc. — silent, ca pe live */ }
  }

  function saved() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  /* ── Randare ─────────────────────────────────────────────────── */
  var DEFAULT_ICONS = {
    severity: ['◐', '◑', '●', '◉'],
    duration: ['📅', '⏳', '📆', '🔁'],
    context: ['☀️', '🌙', '🏃', '⚡', '💼', '🚿', '🛏️', '🥶'],
    multi: ['◯', '◯', '◯', '◯', '◯', '◯', '◯', '◯']
  };

  function defaultSchemeForStep(stepIndex, qType) {
    if (qType === 'cross') return null;
    if (qType === 'multi') return 'multi';
    /* Q1 = severitate, Q2 = durată, Q3 = context — la fel pe toate cele 8 trasee. */
    if (stepIndex === 0) return 'severity';
    if (stepIndex === 1) return 'duration';
    if (stepIndex === 2) return 'context';
    return null;
  }

  function iconFor(q, i, isCross, optionsList, stepIndex) {
    if (isCross) {
      var hit = ALL_PROBLEMS.filter(function (p) { return p.label === optionsList[i]; })[0];
      return hit ? hit.icon : '✓';
    }
    if (q.icons && q.icons[i]) return q.icons[i];
    var scheme = q.iconScheme || defaultSchemeForStep(stepIndex, q.type);
    if (scheme && DEFAULT_ICONS[scheme]) return DEFAULT_ICONS[scheme][i] || '○';
    return '•';
  }

  function optionHTML(label, icon, index, isMulti) {
    return '<button type="button" class="dl-quiz-option ' + (isMulti ? 'dl-quiz-option--multi' : '') + '" data-quiz-pick="' + index + '">' +
      '<span class="dl-quiz-option-icon" aria-hidden="true">' + icon + '</span>' +
      '<span class="dl-quiz-option-label">' + escapeHTML(label) + '</span>' +
      '<span class="dl-quiz-option-check" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
      '</span>' +
      '</button>';
  }

  function renderTiles() {
    if (!refs.tiles) return;
    refs.tiles.innerHTML = activeProblems().map(function (p) {
      return '<button type="button" class="dl-quiz-option" data-quiz-start="' + p.key + '" role="listitem">' +
        '<span class="dl-quiz-option-icon" aria-hidden="true">' + p.icon + '</span>' +
        '<span class="dl-quiz-option-label">' + escapeHTML(p.label) + '</span>' +
        '</button>';
    }).join('');
  }

  /* Etapele sunt <div data-stage> din overlay (start / intro / quiz / result); ascunderea se
     face pe ele, nu pe conținutul dinăuntru. La schimbarea etapei urcăm scroll-ul overlay-ului.
     Etapa curentă ajunge și pe overlay (data-quiz-stage), ca CSS-ul să poată liniști bara de sus
     pe ecranul de start. Un overlay vechi, fără etapa „start”, cade pe „intro”. */
  function stageName(name) {
    if (name === 'start' && overlay && !overlay.querySelector('[data-stage="start"]')) return 'intro';
    return name;
  }

  function showStage(name) {
    if (!overlay) return;
    name = stageName(name);
    overlay.querySelectorAll('[data-stage]').forEach(function (el) {
      el.hidden = el.getAttribute('data-stage') !== name;
    });
    overlay.setAttribute('data-quiz-stage', name);
    overlay.scrollTop = 0;
  }

  /* Eticheta din bara de sus: pe start și la subiecte încă nu există „pasul 1 din 5”. */
  function stageLabel(name) {
    return stageName(name) === 'start' ? 'Plan personalizat' : 'QUIZ · 1 / 5';
  }

  function currentQuestion() {
    var path = QUIZ[state.problem];
    return path ? path.questions[state.step] : null;
  }

  function setProgress(label, ratio) {
    if (refs.progressLabel) refs.progressLabel.textContent = label;
    if (refs.progressFill) refs.progressFill.style.width = Math.round(ratio * 100) + '%';
  }

  function renderQuestion() {
    var q = currentQuestion();
    if (!q) { renderResult(); return; }
    var total = QUIZ[state.problem].questions.length;
    setProgress('QUIZ · ' + (state.step + 1) + ' / ' + total, state.step / total);

    var isCross = q.type === 'cross';
    var optionsList;
    if (isCross) {
      optionsList = crossProblems(state.problem).map(function (p) { return p.label; });
      optionsList.push(CROSS_NONE);
    } else {
      optionsList = q.options;
    }
    var isMulti = q.type === 'multi' || isCross;

    var html = '';
    if (q.helper) html += '<p class="dl-quiz-helper">' + q.helper + '</p>';
    html += '<h3 class="dl-quiz-prompt" data-quiz-heading tabindex="-1">' + q.prompt + '</h3>';
    html += '<div class="dl-quiz-options" role="' + (isMulti ? 'group' : 'radiogroup') + '">';
    optionsList.forEach(function (label, i) {
      html += optionHTML(label, iconFor(q, i, isCross, optionsList, state.step), i, isMulti);
    });
    html += '</div>';
    if (isMulti) {
      html += '<div class="dl-quiz-multi-cta">' +
        '<button type="button" class="dl-quiz-next-btn" data-quiz-confirm-multi>Mai departe →</button>' +
        '</div>';
    }

    refs.content.innerHTML = html;
    if (refs.validation) refs.validation.hidden = true;

    var picked = state.answers[state.step];
    if (Array.isArray(picked)) {
      picked.forEach(function (idx) {
        var btn = refs.content.querySelector('[data-quiz-pick="' + idx + '"]');
        if (btn) btn.classList.add('is-active');
      });
    }
    focusHeading(refs.content);
  }

  /* Titlul etapei curente primește focusul, ca cititoarele de ecran să anunțe întrebarea nouă.
     id-ul dlQuizHeading rămâne pe promptul static din intro (aria-labelledby-ul dialogului),
     deci titlurile randate dinamic folosesc data-quiz-heading — fără id-uri duplicate. */
  function focusHeading(scope) {
    var h = scope && scope.querySelector('[data-quiz-heading]');
    if (h && h.focus) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
  }

  function showValidation(text, then) {
    if (!refs.validation || !refs.validationText) { if (then) then(); return; }
    refs.validationText.textContent = text;
    refs.validation.hidden = false;
    clearTimeout(validationTimer);
    validationTimer = setTimeout(function () {
      refs.validation.hidden = true;
      if (then) then();
    }, 1500);
  }

  function pickSingle(idx) {
    var q = currentQuestion();
    state.answers[state.step] = [idx];
    persist();
    refs.content.querySelectorAll('.dl-quiz-option').forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
    var advance = function () { state.step++; renderQuestion(); };
    if (q.validation) showValidation(q.validation, advance);
    else setTimeout(advance, 280);
  }

  function toggleMulti(idx) {
    var current = state.answers[state.step] || [];
    var pos = current.indexOf(idx);
    if (pos >= 0) current.splice(pos, 1); else current.push(idx);
    state.answers[state.step] = current;
    persist();
    refs.content.querySelectorAll('.dl-quiz-option').forEach(function (b, i) { b.classList.toggle('is-active', current.indexOf(i) >= 0); });
  }

  function productCardHTML(product, stepLabel) {
    var cta = product.variantId
      ? '<button type="button" class="dl-quiz-product-cta" data-dl-quiz-add="' + escapeHTML(product.variantId) + '">' +
        '<span class="dl-quiz-product-price">' + escapeHTML(product.price) + '</span>Adaugă în coș' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '</button>'
      : '<a class="dl-quiz-product-cta" href="' + escapeHTML(product.url) + '">' +
        '<span class="dl-quiz-product-price">' + escapeHTML(product.price) + '</span>Vezi protocolul' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '</a>';
    return '<div class="dl-quiz-product">' +
      '<img class="dl-quiz-product-img" src="' + escapeHTML(product.img) + '" alt="' + escapeHTML(product.title) + '" loading="lazy">' +
      '<div>' +
      (stepLabel ? '<p class="dl-quiz-result-eyebrow">' + escapeHTML(stepLabel) + '</p>' : '') +
      '<h3 class="dl-quiz-product-title">' + escapeHTML(product.title) + '</h3>' +
      (product.protocol ? '<p class="dl-quiz-product-protocol">' + escapeHTML(product.protocol) + '</p>' : '') +
      cta +
      (product.variantId ? '<a class="dl-quiz-product-link" href="' + escapeHTML(product.url) + '">Vezi pagina produsului</a>' : '') +
      '</div>' +
      '</div>';
  }

  function renderResult() {
    var data = resultFor(state.problem, state.answers);
    if (!data) return;
    var total = QUIZ[state.problem].questions.length;
    setProgress(total + ' / ' + total, 1);
    showStage('result');

    var html = '';
    html += '<p class="dl-quiz-result-eyebrow">Recomandarea ta</p>';
    html += '<h2 class="dl-quiz-result-preface" data-quiz-heading tabindex="-1">' + data.result.preface + '</h2>';
    html += '<p class="dl-quiz-result-pitch">' + data.result.pitch + '</p>';
    if (data.result.quote) {
      html += '<blockquote class="dl-quiz-quote">' +
        '<p class="dl-quiz-quote-text">«' + data.result.quote.text + '»</p>' +
        '<p class="dl-quiz-quote-author">' + data.result.quote.author + '</p>' +
        '</blockquote>';
    }
    html += productCardHTML(data, data.secondary ? 'Pasul 1' : '');
    /* Al doilea produs al blocului („produs secundar") — pe live: Matrix + plasturi. */
    if (data.secondary && data.secondary.title) {
      html += productCardHTML(merge({ url: data.url }, data.secondary), 'Pasul 2');
    }

    if (data.cross.length) {
      var first = data.cross[0];
      html += '<div class="dl-quiz-cross">' +
        '<h4 class="dl-quiz-cross-title">Văd că ai bifat și „' + escapeHTML(first.label) + '"</h4>' +
        '<p class="dl-quiz-cross-blurb">Mariana avea exact aceeași combinație. ' +
        'Mai poți adăuga <strong>' + escapeHTML(first.product.title) + '</strong> — ' + escapeHTML(first.product.protocol) + '</p>' +
        '<a class="dl-quiz-product-cta" href="' + escapeHTML(first.product.url) + '">Vezi și ' + escapeHTML(first.product.title) +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '</a>' +
        '</div>';
    }

    html += '<button type="button" class="dl-quiz-restart-link" data-quiz-restart>' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>' +
      'Reia quiz-ul' +
      '</button>';

    refs.result.innerHTML = html;
    focusHeading(refs.result);
    persist({ completed: true, recommended: state.problem, crossSell: data.cross.map(function (c) { return c.key; }) });
  }

  /* ── Flux ────────────────────────────────────────────────────── */
  function start(problemKey) {
    if (!QUIZ[problemKey]) return;
    state.problem = problemKey;
    state.step = 0;
    state.answers = [];
    showStage('quiz');
    renderQuestion();
    persist();
  }

  /* `stage`: 'start' (ecranul de început, la deschidere) sau 'intro' (alegerea subiectului —
     implicit, pentru „Reia quiz-ul” și „Înapoi” de la prima întrebare). */
  function reset(stage) {
    clearTimeout(validationTimer);
    state = { problem: null, step: 0, answers: [] };
    stage = stage === 'start' ? 'start' : 'intro';
    setProgress(stageLabel(stage), 0);
    showStage(stage);
  }

  /* „Începe”: de la ecranul de start la alegerea subiectului. */
  function begin() {
    reset('intro');
    var first = refs.tiles && refs.tiles.querySelector('[data-quiz-start]');
    if (first && first.focus) first.focus();
  }

  function back() {
    if (state.step > 0) { state.step--; renderQuestion(); }
    else reset();
  }

  function addToCart(btn) {
    var id = Number(btn.getAttribute('data-dl-quiz-add'));
    var DL = root.DL;
    if (!id || !DL || !DL.cart) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Se adaugă…';
    DL.cart.add([{ id: id, quantity: 1 }]).then(function () {
      btn.innerHTML = label;
      btn.disabled = false;
      close();
      if (DL.drawer) DL.drawer.open();
      else if (DL.toast) DL.toast('Adăugat în coș');
    }).catch(function (err) {
      btn.innerHTML = label;
      btn.disabled = false;
      if (DL.toast) DL.toast((err && err.message) || 'Nu am putut adăuga produsul.', 'err');
    });
  }

  /* ── Overlay ─────────────────────────────────────────────────── */
  function isOpen() { return !!overlay && overlay.classList.contains('is-open'); }

  /* Quiz-ul se deschide și din meniul de telefon („Plan personalizat”). Meniul e tot un panou
     peste pagină: îl închidem întâi (prin butonul lui, ca aria-expanded și blocarea derulării să
     rămână corecte), altfel ar rămâne deschis în spatele quiz-ului. */
  function closeMobileMenu() {
    var menu = document.getElementById('dlMobileMenu');
    if (!menu || !menu.classList.contains('is-open')) return;
    var toggle = menu.querySelector('[data-dl-mobile-toggle]');
    if (toggle && toggle.click) toggle.click();
  }

  function open(problemKey) {
    if (!overlay) return;
    closeMobileMenu();
    reset('start');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dl-quiz-open');
    if (problemKey && QUIZ[problemKey]) { start(problemKey); return; }
    var first = overlay.querySelector('[data-quiz-begin]') || (refs.tiles && refs.tiles.querySelector('[data-quiz-start]'));
    if (first && first.focus) first.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dl-quiz-open');
    clearTimeout(validationTimer);
    /* declanșatorul din meniul de telefon e acum ascuns (meniul s-a închis): focusul merge pe
       butonul de meniu, nu se pierde pe <body> */
    var target = lastTrigger;
    if (target && target.offsetParent === null) target = document.querySelector('.dl-menu-toggle[data-dl-mobile-toggle]');
    if (target && target.focus) target.focus();
    lastTrigger = null;
  }

  /* Pot exista mai multe hărți în pagină: cea globală din grupul de antet (sections/quiz-products)
     și cea a bannerului de quiz, dacă pagina îl are. Le unim în ordinea din DOM — bannerul vine după
     antet, deci câștigă pe subiectele lui. Un JSON stricat e sărit, celelalte rămân. */
  function readJSON(selector, apply) {
    var els = document.querySelectorAll ? document.querySelectorAll(selector) : [];
    if (!els.length) return;
    var merged = {};
    Array.prototype.forEach.call(els, function (el) {
      try {
        var map = JSON.parse(el.textContent || '{}');
        Object.keys(map || {}).forEach(function (k) { merged[k] = map[k]; });
      } catch (e) { /* JSON invalid — rămâne fallback-ul */ }
    });
    apply(merged);
  }

  function bindOverlay(el) {
    overlay = el;
    refs = {
      result: el.querySelector('[data-quiz-result]'),
      tiles: el.querySelector('.dl-quiz-tiles'),
      content: el.querySelector('[data-quiz-content]'),
      validation: el.querySelector('[data-quiz-validation]'),
      validationText: el.querySelector('[data-quiz-validation-text]'),
      progressLabel: el.querySelector('[data-quiz-progress]'),
      progressFill: el.querySelector('[data-quiz-progress-fill]')
    };
    renderTiles();
    reset('start');

    el.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t === el) { close(); return; } /* fundalul overlay-ului (overlay-ul e full-screen, deci rar) */
      if (t.closest('[data-dl-quiz-close]')) { close(); return; }
      if (t.closest('[data-quiz-exit]')) { persist(); close(); return; }
      if (t.closest('[data-quiz-begin]')) { begin(); return; }
      if (t.closest('[data-quiz-to-start]')) { reset('start'); var beginBtn = el.querySelector('[data-quiz-begin]'); if (beginBtn) beginBtn.focus(); return; }
      var startEl = t.closest('[data-quiz-start]');
      if (startEl) { start(startEl.getAttribute('data-quiz-start')); return; }
      var pickEl = t.closest('[data-quiz-pick]');
      if (pickEl) {
        var q = currentQuestion();
        if (!q) return;
        var idx = parseInt(pickEl.getAttribute('data-quiz-pick'), 10);
        if (q.type === 'multi' || q.type === 'cross') toggleMulti(idx);
        else pickSingle(idx);
        return;
      }
      if (t.closest('[data-quiz-confirm-multi]')) { state.step++; renderQuestion(); return; }
      if (t.closest('[data-quiz-back]')) { back(); return; }
      if (t.closest('[data-quiz-restart]')) { reset(); return; }
      var addEl = t.closest('[data-dl-quiz-add]');
      if (addEl) { addToCart(addEl); return; }
    });
  }

  function init(scope) {
    var el = document.getElementById('dlQuiz');
    if (!el || el.dataset.dlBound) {
      /* secțiunea quiz-banner poate fi (re)încărcată din editor după overlay */
      readJSON('[data-dl-quiz-products]', setProducts);
      return;
    }
    el.dataset.dlBound = '1';
    readJSON('[data-dl-quiz-images]', setImages);
    readJSON('[data-dl-quiz-products]', setProducts);
    bindOverlay(el);

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var trigger = e.target.closest('[data-dl-quiz-open], a[href="#quiz"]');
      if (!trigger) return;
      e.preventDefault();
      lastTrigger = trigger;
      open(trigger.getAttribute('data-dl-quiz-open') || null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });
    /* /#quiz deschide quiz-ul la încărcare; hashchange acoperă linkurile către #quiz din
       aceeași pagină care nu trec prin handler-ul de click (back/forward, linkuri injectate). */
    window.addEventListener('hashchange', function () { if (location.hash === '#quiz' && !isOpen()) open(); });
    if (location.hash === '#quiz') open();
  }

  root.DelfinoQuiz = {
    open: open,
    close: close,
    start: start,
    begin: begin,
    reset: reset,
    resultFor: resultFor,
    productFor: productFor,
    activeProblems: activeProblems,
    setProducts: setProducts,
    setImages: setImages,
    saved: saved,
    init: init
  };

  /* Înregistrare în tema Delfino. quiz.js e încărcat (defer) înaintea lui theme.js, deci DL.use
     poate lipsi încă: în cazul ăsta punem direct în coada DL.plugins, pe care theme.js o păstrează. */
  if (typeof document === 'undefined') return;
  var DL = (root.DL = root.DL || {});
  DL.plugins = DL.plugins || [];
  if (typeof DL.use === 'function') DL.use(init); else DL.plugins.push(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})(typeof window === 'undefined' ? globalThis : window);
